import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { alpha, useTheme } from "@mui/material/styles";
import type { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
import MDBox from "components/MDBox";

type PedidoResumoEtapaCardProps = {
  id?: string;
  titulo: string;
  valor: string;
  hint?: string;
  icone?: ReactNode;
  destaque?: boolean;
  /** Link opcional (ex.: tela de faturamento). */
  linkTo?: string;
  linkLabel?: string;
};

export default function PedidoResumoEtapaCard({
  id,
  titulo,
  valor,
  hint,
  icone,
  destaque,
  linkTo,
  linkLabel,
}: PedidoResumoEtapaCardProps) {
  const theme = useTheme();
  const mode = theme.palette.mode;
  const borderSoft =
    mode === "dark" ? alpha("#c8e6c9", 0.45) : alpha("#7cb342", 0.22);

  return (
    <Card
      id={id}
      elevation={0}
      sx={{
        borderRadius: 2,
        border: destaque
          ? `2px solid ${theme.palette.primary.main}`
          : `1px solid ${borderSoft}`,
        boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
        height: "100%",
      }}
    >
      <MDBox p={2}>
        <Stack direction="row" alignItems="flex-start" spacing={1.5}>
          {icone ? (
            <MDBox
              sx={{
                color: theme.palette.primary.main,
                display: "flex",
                mt: 0.25,
              }}
            >
              {icone}
            </MDBox>
          ) : null}
          <Stack spacing={0.5} flex={1} minWidth={0}>
            <Typography
              variant="caption"
              color="text.secondary"
              fontWeight={600}
            >
              {titulo}
            </Typography>
            <Typography variant="body2" fontWeight={700} noWrap title={valor}>
              {valor}
            </Typography>
            {hint ? (
              <Typography variant="caption" color="text.secondary">
                {hint}
              </Typography>
            ) : null}
            {linkTo && linkLabel ? (
              <Link
                component={RouterLink}
                to={linkTo}
                variant="caption"
                fontWeight={700}
                sx={{
                  mt: 0.5,
                  alignSelf: "flex-start",
                  textDecoration: "underline",
                  backgroundColor: alpha(theme.palette.primary.main, 0.1),
                  padding: 1,
                  borderRadius: 1,
                  color: theme.palette.primary.main,
                }}
              >
                {linkLabel}
              </Link>
            ) : null}
          </Stack>
        </Stack>
      </MDBox>
    </Card>
  );
}
